import CATALOG from './mocked-widgets.json';
import { MISSING_VIDEOS } from 'modules/Dashboard/Widgets/Common/WidgetByType/Widgets.types';

const SUPER_ADMIN_ONLY_TYPES = [MISSING_VIDEOS];

export const getWidgetsCatalog = ({ isSuperAdmin }) => {
  if (isSuperAdmin) return CATALOG;

  const widgets = CATALOG.widgets.filter(
    (widget) => !SUPER_ADMIN_ONLY_TYPES.includes(widget.type)
  );
  return { ...CATALOG, widgets, total_items: widgets.length };
};
